var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('b-container',[_c('mini-nav',{staticClass:"mt-4"}),_c('six-angle',{attrs:{"dataList":_vm.list}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }